import { Button } from '@/components/ui/button.js';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog.js';
import { ReactNode } from 'react';

export const HELP_CENTER_NEW_TICKET_URL = 'https://help.airreading.com/support/tickets/new';

interface SubstituteNotAvailableDialogProps {
  trigger: ReactNode;
  disabled?: boolean;
}

/**
 * Read-only modal: substitute cannot be requested after the session start time (see AIR-2194).
 */
export function SubstituteNotAvailableDialog({ trigger, disabled }: SubstituteNotAvailableDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild disabled={disabled}>
        {trigger}
      </DialogTrigger>
      <DialogContent className="z-[60] sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Request substitute not available</DialogTitle>
          <DialogDescription>
            Substitute requests must be submitted before the session start time. For immediate help, contact Air Reading
            Support in Slack, then{' '}
            <a
              href={HELP_CENTER_NEW_TICKET_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-primary underline underline-offset-4"
            >
              Submit a ticket
            </a>{' '}
            in the Help Center.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button type="button" variant="outline">
              Close
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
